/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
const propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  margin: PropTypes.string,
  liveRegion: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  liveRegionPoliteness: PropTypes.oneOf(['polite', 'assertive']),
  isLiveRegionAtomic: PropTypes.bool,
  screenReaderOnly: PropTypes.bool,
  timeout: PropTypes.number,
  renderCloseButtonLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  onDismiss: PropTypes.func,
  transition: PropTypes.oneOf(['none', 'fade']),
  open: PropTypes.bool,
  hasShadow: PropTypes.bool,
  variantScreenReaderLabel: PropTypes.string,
  renderCustomIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};
const allowedProps = ['children', 'variant', 'margin', 'liveRegion', 'liveRegionPoliteness', 'isLiveRegionAtomic', 'screenReaderOnly', 'timeout', 'renderCloseButtonLabel', 'onDismiss', 'transition', 'open', 'hasShadow', 'renderCustomIcon'];
export { propTypes, allowedProps };